import { tap, take, catchError } from 'rxjs/operators';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Observable, Subject, timer, empty, EMPTY } from 'rxjs';
import { Servidor } from '../_classes/servidor';
import { SgrhCreditoDia } from '../_classes/sgrh-credito-dia';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { RestService } from '../_servicos/rest.service';
import { ServidorService } from '../_servicos/servidor.service';
import { ModalAlertaService } from '../shared/modal-alerta.service';
import { ModalAjudaService } from '../shared/modal-ajuda.service';
import { Util } from '../_classes/util';
import { EnvService } from '../_servicos/env.service';

@Component({
  selector: 'app-sgrh-credito-dia',
  templateUrl: './sgrh-credito-dia.component.html',
  styleUrls: ['./sgrh-credito-dia.component.scss'],
})
export class SgrhCreditoDiaComponent implements OnInit {
  carregando = false;
  displayedColumns: string[] = [
    'dtInicio',
    'dsEvento',
    'nrDiaMarcado',
    'nrDiaTrabalhado',
  ];

  totalDias: number = 0;
  dsCreditoDia$: Observable<number>;

  //servidor$: Observable<Servidor>;
  //servidor: Servidor = new Servidor();

  erros$ = new Subject<boolean>();
  dataSource$: Observable<SgrhCreditoDia[]>;
  dataSource: MatTableDataSource<SgrhCreditoDia>;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  itensAjuda = [
    {
      titulo: 'Período',
      texto: 'Período no qual foi-se trabalhado, para gerar o crédito',
    },
    {
      titulo: 'Evento',
      texto: 'Descrição do evento que gerou o crédito',
    },
    {
      titulo: 'Marcado',
      texto: 'Quantidade de dias marcados para usufruir',
    },
    {
      titulo: 'Trabalhado',
      texto: 'Quantidade de dias que foram trabalhados, gerando o crédito',
    },
  ];

  private t: any;

  ngOnDestroy() {
    if (this.t) {
      this.t.unsubscribe();
    }
  }

  constructor(
    private service: RestService,
    private servService: ServidorService,
    private alertService: ModalAlertaService,
    private ajudaService: ModalAjudaService,
    private env: EnvService
  ) {
    //this.dataSource = new MatTableDataSource([]);
  }

  // setPageSizeOptions(setPageSizeOptionsInput: string) {
  //   this.pageSizeOptions = setPageSizeOptionsInput.split(',').map(str => +str);
  // }

  ngOnInit() {
    this.atualizar();
  }
  /*
  executarAoCarregarServidor(x: Servidor) {
    this.servidor = new Servidor(x);
  }*/

  executarAoCarregarDatasource(x: SgrhCreditoDia[]) {
    //console.log('lista de CREDITO-DIA', x);
    this.dataSource = new MatTableDataSource<SgrhCreditoDia>(x);
    if (this.dataSource) {
      this.dataSource.paginator = this.paginator;

      this.dataSource.sort = this.sort;
      this.dataSource.sortingDataAccessor = this.sortingDataAccessor;
    }
    this.carregando = false;
  }

  sortingDataAccessor(item, property) {
    if (property.includes('.')) {
      return property.split('.').reduce((object, key) => object[key], item);
    }
    return item[property];
  }

  atualizar() {
    this.carregando = true;
    this.t = timer(20000).subscribe((v) => {
      if (this.carregando) {
        this.carregando = false;
        this.handleError(
          'Excedido tempo de carregamento (' + this.constructor.name + ')'
        );
      }
    });
    if (this.env.servidor) {
      this.listar();
    } else {
      //this.servService.getServidorComFuncao(() => {this.listar();});
      this.servService.getServidorComFuncao2().then(() => this.listar());
    }
  }

  listar() {
    this.dataSource$ = this.service
      .listarSgrhCreditoDia(this.env.servidor.idServidor)
      .pipe(
        tap((a) => this.executarAoCarregarDatasource(a)),
        take(1),
        catchError((e) => {
          this.handleError(e);
          return EMPTY;
        })
      );

    this.service
      .getQuantidadeSgrhCreditoDia(this.env.servidor.idServidor)
      .pipe(take(1))
      .subscribe(
        (a) => {
          this.totalDias = a;
          //console.log('retornei a quantidade de dias (getQuantidadeSgrhCreditoDia)'      );
          //console.log(a);
        },
        (e) => {
          this.handleError(e);
          return EMPTY;
        }
      );
  }
  /*
  atualizarOld() {
    this.carregando = true;
    this.t = timer(20000).subscribe((v) => {
      if (this.carregando) {
        this.carregando = false;
        this.handleError(
          'Excedido tempo de carregamento (' + this.constructor.name + ')'
        );
      }
    });
    this.servidor = this.servService.getServidorAtualRedirecionando(
      'sgrh-credito-dia'
    );

    this.servidor$ = this.servService.getServidor().pipe(
      tap((x) => this.executarAoCarregarServidor(x)),
      take(1),
      catchError((e) => {
        this.handleError(e);
        return empty();
      })
    );

    if (this.servidor) {
      this.dataSource$ = this.service
        .listarSgrhCreditoDia(this.servidor.idServidor)
        .pipe(
          tap((a) => this.executarAoCarregarDatasource(a)),
          take(1),
          catchError((e) => {
            this.handleError(e);
            return EMPTY;
          })
        );

      this.service
        .getQuantidadeSgrhCreditoDia(this.servidor.idServidor)
        .pipe(take(1))
        .subscribe(
          (a) => {
            this.totalDias = a;
            //console.log('retornei a quantidade de dias (getQuantidadeSgrhCreditoDia)'      );
            //console.log(a);
          },
          (e) => {
            this.handleError(e);
            return EMPTY;
          }
        );
    }
  }*/

  periodo(dI: Date, dF: Date) {
    //console.log("dI:", dI, "dF:", dF);
    dF = dF === null ? dI : dF;
    return Util.periodoMesAbreviado(dI, dF);
  }
  dataStr(d: Date) {
    return Util.dataMesAbrev(d);
  }

  vencido(d: SgrhCreditoDia): boolean {
    let retorno: boolean = false;
    if (d) {
      if (d?.dtValidade) {
        if (d?.nrDiaMarcado) {
          if (d?.nrDiaTrabalhado) {
            if (d?.nrDiaTrabalhado > d?.nrDiaMarcado) {
              retorno = Util.dataVencida(new Date(d.dtValidade), new Date());
            }
          }
        }
      }
    }
    return retorno;
  }

  mostrarAjudaModal() {
    this.ajudaService.mostrar(this.itensAjuda, '');
  }

  handleError(e: any) {
    this.erros$.next(true);
    this.alertService.mostrarAlertaPerigo(
      'Erro, tente novamente mais tarde',
      e
    );
  }
}
